import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    llactivityLogList: [],
    llactivityLogRecord: [],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
    showFollowupModel: false,
}

const LodgelinkActivityLogReducer = (state = initialState, action) => {
    switch (action.type) {
       
    case actionTypes.LL_ACTIVITY_LOG_REQUEST:
        return {
          ...state,
          Loading: true,
          validation_error: "",
          redirect_to_list: false,
        }
    case actionTypes.LL_ACTIVITY_LOG_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          llactivityLogList: action.llactivityLogList,
          showUpdateForm: false,
          showViewPage: false,
          showFollowupModel: false,
          llactivityLogRecord: [],
        }
    case actionTypes.LL_ACTIVITY_LOG_SERVER_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          showUpdateForm: false,
          showViewPage: false,
          showFollowupModel: false,
          llactivityLogRecord: [],
        }   
    case actionTypes.LL_ACTIVITY_AGENT_REPORT_SERVER_SUCCESS:
        return {
            ...state, 
            Loading: false,
            redirect_to_list: false,
        } 
    case actionTypes.LL_ACTIVITY_LOG_GET_SUCCESS:
        return {
            ...state, 
            Loading: false,
            redirect_to_list: false,
            llactivityLogRecord: action.record,
            showUpdateForm: (action.actionType === 'update')? true:false,
            showViewPage: (action.actionType === 'view')? true:false,
            showFollowupModel: (action.actionType === 'followup')? true:false,
        }    
    case actionTypes.LL_ACTIVITY_LOG_VALIDATION_ERROR:
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
        } 
    case actionTypes.HIDE_LL_ACTIVITY_LOG_FEILD_VALIDATION_ERROR:
        if(state.validation_error && state.validation_error[action.feild_key])
            delete state.validation_error[action.feild_key]
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
            
        } 
    case actionTypes.REDIRECT_TO_LL_ACTIVITY_LOG_LIST:
        return {
            ...state,
            redirect_to_list: true,
            showUpdateForm: false,
            showViewPage: false,
            showFollowupModel: false,
            validation_error: '',
            llactivityLogRecord: [],
        }

    default:
        return state;
    }
}

export default LodgelinkActivityLogReducer;